import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  window.console.log = () => null;
}

document.addEventListener('keydown', (evt) => {
  if (evt.key == 'F5' && !evt.shiftKey) evt.preventDefault();
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
